<div class="container-button-demandes">
  <div>
    <button mat-raised-button class="save-btn" color="accent" (click)="onAdd()">
      <mat-icon>add</mat-icon>
      Ajouter
    </button>
    <button mat-raised-button class="save-btn" color="accent" (click)="onSave()">
      <mat-icon>save</mat-icon>
      Enregistrer
    </button>
  </div>
</div>
<div class="row">
  @if (dataSourceDemandes.data.length === 0) {
  <div>
    <p class="text-center">Aucune demande n'a été trouvée pour cette officine</p>
  </div>
  } @else {
  <table mat-table [dataSource]="dataSourceDemandes.data">
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        @if (isEditable(element)) {
        <button mat-icon-button (click)="onDeleteDemande(element)">
          <mat-icon>delete</mat-icon></button
        >}
      </td>
    </ng-container>
    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef>Nom</th>
      <td mat-cell *matCellDef="let element">
        @if (!isEditable(element)) { {{ element.lastName }} } @else {<input
          [(ngModel)]="element.lastName"
          placeholder="Nom"
          capitalize
        />}
      </td>
    </ng-container>
    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef>Prénom</th>
      <td mat-cell *matCellDef="let element">
        @if (!isEditable(element)) { {{ element.firstName }} } @else {<input
          [(ngModel)]="element.firstName"
          placeholder="Prénom"
          capitalize
        />
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let element">
        @if (!isEditable(element)) { {{ element.email }} } @else {<input
          [(ngModel)]="element.email"
          placeholder="courriel"
        />
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="titulaire">
      <th mat-header-cell *matHeaderCellDef>Titulaire</th>
      <td mat-cell *matCellDef="let element">
        <mat-checkbox
          [checked]="element.roles?.includes(getTitulaireRole(element))"
          [disabled]="!isEditable(element)"
          (change)="setSelected($event.checked, getTitulaireRole(element), element)">
          Titulaire principal
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="roles">
      <th mat-header-cell *matHeaderCellDef>Rôle</th>
      <td mat-cell *matCellDef="let element">
        @for(item of listeRoles; track item) { @if (item.role !== ROLE_ACCUEIL && item.role !== ROLE_ACCUEIL_GPO){
        <mat-checkbox
          [disabled]="!isEditable(element)"
          [checked]="element.roles.includes(item.role)"
          (change)="setSelected($event.checked, item.role, element)"
          >{{ item.name }}
        </mat-checkbox>
        } }
      </td>
    </ng-container>
    <ng-container matColumnDef="request">
      <th mat-header-cell *matHeaderCellDef>Demande</th>
      <td mat-cell *matCellDef="let element">
        @if (!isEditable(element) && element.isInactivated) {Désactivé} @else if
        (isEditable(element)) {Création ?} @else if (!isEditable(element)) {Création en cours}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell center" colspan="12">Aucune demande trouvée pour cette officine</td>
    </tr>
  </table>
  }
</div>
